import { memo } from 'react';
import { Person } from './Person';

export default memo(Person);



// WEBPACK FOOTER //
// ./components/molecules/Person/index.js